import { GET_CATEGORY_NEWS_VIDEOS, GET_FANTASY_ARTICLE_OF_CATEGORY, GET_SERIES_NEWS_VIDEOS } from '@graphql/series/home.query'
import { LIST_SERIES_TEAMS } from '@graphql/series/teams.query'
import { GET_CATEGORY_BY_ID } from '@graphql/category/category.query'
import { FETCH_TEAM_VENUE, FIXTURES_LIST } from '@graphql/series/fixtures.query'
import { GET_ROUNDS, GET_STANDING_DATA } from '@graphql/series/standings.query'
import { FETCH_SERIES_STATS_TYPE, STATS, MATCH_TYPES } from '@graphql/series/stats.query'
import { GET_ARCHIVES } from '@graphql/series/archives.query'
import { TOP_PLAYERS } from '@graphql/series/topPlayers.query'
import queryGraphql from '../components/queryGraphql'
import { GET_TEAM_PLAYER } from '@graphql/series/squads.query'
import { LIST_SERIES_FANTASY_TIPS } from '@graphql/series/fantasy-tips.query'
import { SERIES_MINI_SCORECARD } from '@graphql/home/home.query'
import { GET_SUB_PAGE_BY_SLUG } from '@graphql/seo/seo.query'
// import { GET_LIVE_AUCTION_SUMMARY_QUERY } from '@graphql/ipl-auction/ipl-auction-live.query'
import { IPL_AUCTION_TEAMS, IPL_AUCTION_TEAMS_BY_ID } from '@graphql/ipl-auction/ipl-auction.query'
import { GET_AUCTION_PLAYER_DETAIL, GET_LIST_AUCTION_PLAYER } from '@graphql/ipl-auction/ipl-auction-list-players'
import { GET_LIVE_AUCTION_OVERVIEW, GET_LIVE_AUCTION_SUMMARY_QUERY } from '@graphql/ipl-auction/ipl-auction-live.query'

export const payload = (limit) => {
  return { nSkip: 1, nLimit: limit, sSortBy: 'dCreated', nOrder: -1 }
}

export const categorySlug = [
  'news',
  'videos',
  'fantasy-articles',
  'fixtures',
  'standings',
  'stats',
  'archives',
  'photos',
  'teams',
  'squads',
  'fantasy-tips'
]
async function getSeriesScoreCard(category) {
  if (category?.eType === 'as') {
    const { data: scoreCard } = await queryGraphql(SERIES_MINI_SCORECARD, { input: { _id: category?.iSeriesId } })
    return scoreCard?.listSeriesScorecard || []
  } else return []
}

// async function getBannerSeriesScoreCard() {
//   const { data: scoreCard } = await queryGraphql(SERIES_MINI_SCORECARD, { input: { _id: '649ac0872979adc89b9606f0' } })
//   return scoreCard?.listSeriesScorecard || []
// }

export async function getCategorySSRData(seo, tabType, isAmp, query, iPlayerID) {
  const {
    data: { getCategoryByIdFront }
  } = await queryGraphql(GET_CATEGORY_BY_ID, { input: { _id: seo?.eSubType === 'ati' ? seo?.iSecondResourceId : seo?.iId } })
  const category = getCategoryByIdFront

  let rData = { type: tabType || 'home', data: category }
  if (category?.eType === 'as') {
    // Series
    const api = [queryGraphql(GET_SUB_PAGE_BY_SLUG, { input: { sSlug: seo?.sSlug } }), getSeriesScoreCard(category)]
    // if (isAmp) api.push(getBannerSeriesScoreCard())

    const [subPages, scoreCard, promotionData] = await Promise.allSettled(api)
    rData = {
      ...rData,
      seriesScoreCard: scoreCard?.value || null,
      subPages: subPages.value?.data?.getSeosBySlug || null,
      bannerSeriesScoreCard: promotionData?.value || null
    }

    if (tabType === 'news') {
      const { data: newsData } = await queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: { ...payload(isAmp ? 32 : 16), iSeriesId: category?.iSeriesId, eType: 'n' }
      })
      rData = { ...rData, newsData: newsData?.listSeriesArticlesVideosFront?.oArticles }
    } else if (tabType === 'videos') {
      const { data: newsVideo } = await queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: { ...payload(isAmp ? 16 : 7), iSeriesId: category?.iSeriesId, eType: 'v' }
      })
      rData = { ...rData, videosData: newsVideo?.listSeriesArticlesVideosFront?.oVideos }
    } else if (tabType === 'fixtures') {
      const [fixture, teamVenue] = await Promise.allSettled([
        queryGraphql(FIXTURES_LIST, {
          input: {
            iSeriesId: category?.iSeriesId,
            nOrder: 1,
            sSortBy: 'dStartDate',
            iTeamId: query?.iTeamId || null,
            iVenueId: query?.iVenueId || null
          }
        }),
        queryGraphql(FETCH_TEAM_VENUE, { input: { iSeriesId: category?.iSeriesId } })
      ])
      rData = { ...rData, fixturesData: fixture?.value?.data, teamData: teamVenue?.value?.data }
    } else if (tabType === 'standings') {
      const [round, standings] = await Promise.allSettled([
        queryGraphql(GET_ROUNDS, { input: { iSeriesId: category?.iSeriesId } }),
        queryGraphql(GET_STANDING_DATA, { input: { iRoundId: null, iSeriesId: category?.iSeriesId } })
      ])
      rData = { ...rData, roundData: round?.value?.data || null, standingData: standings?.value?.data || null }
    } else if (tabType === 'stats') {
      const { data: seriesData } = await queryGraphql(FETCH_SERIES_STATS_TYPE, { input: { eGroupTitle: 'All' } })
      let selectedStats
      if (seo?.eSubType !== 'st') {
        selectedStats = seriesData?.fetchSeriesStatsTypes.filter((i) => {
          return i?.eSubType === seo?.eSubType
        })
      }
      const id = seo?.eSubType !== 'st' ? selectedStats[0]?._id : seriesData?.fetchSeriesStatsTypes[0]?._id
      if (category?.oSeries?.sSeriesType === 'tour' || category?.oSeries?.sSeriesType === 'series') {
        const { data: matchTypeData } = await queryGraphql(MATCH_TYPES, { input: { iSeriesId: category?.iSeriesId } })
        const { data: statsData } = await queryGraphql(STATS, {
          input: { iSeriesId: category?.iSeriesId, _id: id, eFormat: matchTypeData?.listSeriesStatsFormat[0] }
        })
        rData = { ...rData, statsData: statsData || null, seriesData, matchTypeData }
      } else {
        const { data: statsData } = await queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: id, nLimit: 20 } })
        rData = { ...rData, statsData: statsData || null, seriesData }
      }
    } else if (tabType === 'archives') {
      const { data: seriesArchivesData } = await queryGraphql(GET_ARCHIVES, { input: { iSeriesId: category?.iSeriesId } })
      rData = { ...rData, seriesArchivesData }
    } else if (tabType === 'teams') {
      const { data: seriesTeamData } = await queryGraphql(LIST_SERIES_TEAMS, { input: { iSeriesId: category?.iSeriesId } })
      rData = { ...rData, seriesTeamData }
    } else if (tabType === 'squads') {
      const { data: seriesTeamData } = await queryGraphql(LIST_SERIES_TEAMS, { input: { iSeriesId: category?.iSeriesId } })
      if (seriesTeamData?.listSeriesTeams?.aTeams?.length) {
        const iTeamId = query?.teamId || seriesTeamData?.listSeriesTeams?.aTeams[0]?._id
        const { data: teamPlayer } = await queryGraphql(GET_TEAM_PLAYER, { input: { iSeriesId: category?.iSeriesId, iTeamId } })
        rData = { ...rData, seriesTeamData, teamPlayer: teamPlayer?.listSeriesSquad }
      } else {
        rData = { ...rData, seriesTeamData, teamPlayer: [] }
      }
    } else if (tabType === 'fantasy-tips') {
      const { data: seriesFantasyTips } = await queryGraphql(LIST_SERIES_FANTASY_TIPS, {
        input: { iSeriesId: category?.iSeriesId, nOrder: -1, sSortBy: 'dStartDate' }
      })
      rData = { ...rData, seriesFantasyTips }
    } else {
      // Home
      const [article, fantasy, topPlayer] = await Promise.allSettled([
        queryGraphql(GET_SERIES_NEWS_VIDEOS, { input: { ...payload(32), iSeriesId: category?.iSeriesId, eType: 'vn' } }),
        queryGraphql(GET_FANTASY_ARTICLE_OF_CATEGORY, { input: { ...payload(16), iId: seo?.iId } }),
        queryGraphql(TOP_PLAYERS, { input: { iSeriesId: category?.iSeriesId } })
      ])
      rData = {
        ...rData,
        home: {
          oArticles: article?.value?.data?.listSeriesArticlesVideosFront?.oArticles || null,
          oVideos: article?.value?.data?.listSeriesArticlesVideosFront?.oVideos || null,
          fantasyArticle: fantasy?.value?.data?.listFrontTagCategoryFantasyArticle || null
        },
        playerData: topPlayer?.value?.data || null
      }
    }
  } else {
    // Simple

    if (category?.oAuctionSeries?._id) {
      const api = [queryGraphql(GET_SUB_PAGE_BY_SLUG, { input: { sSlug: category?.oSeo?.sSlug } })]
      // const [subPages] = await Promise.allSettled(api)

      // rData = {
      //   ...rData,
      //   subPages: subPages.value?.data?.getSeosBySlug || null
      // }
      if (iPlayerID) {
        api.push(
          queryGraphql(GET_AUCTION_PLAYER_DETAIL, {
            input: { _id: iPlayerID }
          })
        )
        const [subPages, player] = await Promise.allSettled(api)
        rData = {
          ...rData,
          playerData: player?.value?.data?.getAuctionPlayerFront?.oData,
          iPlayerID,
          subPages: subPages.value?.data?.getSeosBySlug || null
        }
      } else if (seo?.eSubType === 'ati') {
        api.push(queryGraphql(IPL_AUCTION_TEAMS_BY_ID, { input: { _id: seo?.iId } }))
        api.push(queryGraphql(IPL_AUCTION_TEAMS, { input: { iAuctionSeriesId: category?.oAuctionSeries?._id } }))
        const [subPages, teamDetail, teamList] = await Promise.allSettled(api)
        rData = {
          ...rData,
          teamDetail: teamDetail?.value?.data?.getAuctionTeamFront || null,
          teamList: teamList?.value?.data?.listAuctionTeamFront || null,
          subPages: subPages.value?.data?.getSeosBySlug || null
        }
      } else if (rData?.type === 'home') {
        if (category?.oAuctionSeries?.eAuctionStatus === 'c') {
          api.push(
            queryGraphql(GET_LIST_AUCTION_PLAYER, {
              input: {
                nLimit: 6,
                nSkip: 0,
                eAuctionStatus: 's',
                sSortBy: 'nSoldPrice',
                nOrder: -1,
                iSeriesId: category?.oAuctionSeries?._id
              }
            })
          )
          api.push(queryGraphql(GET_LIVE_AUCTION_OVERVIEW, { input: { _id: category?.oAuctionSeries?._id } }))
        } else if (category?.oAuctionSeries?.eAuctionStatus === 'l') {
          api.push(
            queryGraphql(GET_LIVE_AUCTION_SUMMARY_QUERY, {
              input: { iAuctionSeriesId: category?.oAuctionSeries?._id }
            })
          )
        }
        const [subPages, playerAndLive, overView] = await Promise.allSettled(api)
        // const [{ value: teams }, { value: players }] = await Promise.allSettled([
        //   queryGraphql(IPL_AUCTION_TEAMS, { input: { iAuctionSeriesId: category?.oAuctionSeries?._id } }),
        //   queryGraphql(GET_LIST_AUCTION_PLAYER, {
        //     input: {
        //       nLimit: 6,
        //       nSkip: 0,
        //       eAuctionStatus: 's',
        //       sSortBy: 'nSoldPrice',
        //       nOrder: -1,
        //       iSeriesId: category?.oAuctionSeries?._id
        //     }
        //   }),
        //   queryGraphql(GET_LIVE_AUCTION_OVERVIEW, { input: { _id: category?.oAuctionSeries?._id } })
        // ])

        rData = {
          ...rData,
          liveData: playerAndLive?.value?.data || null,
          topsPicks: playerAndLive?.value?.data?.listAuctionPlayerFront?.aData || null,
          // teams: teams?.data?.listAuctionTeamFront?.aData || null,
          overView: overView?.value?.data?.getAuctionSeriesOverview || null,
          subPages: subPages.value?.data?.getSeosBySlug || null
        }
      } else if (rData?.type === 'teams') {
        api.push(queryGraphql(IPL_AUCTION_TEAMS, { input: { iAuctionSeriesId: category?.oAuctionSeries?._id } }))
        const [subPages, teamData] = await Promise.allSettled(api)
        rData = { ...rData, actionTeamData: teamData?.value?.data || null, subPages: subPages.value?.data?.getSeosBySlug || null }
      } else if (rData?.type === 'completed') {
        if (query?.iCountryId) query.iPrimaryTeam = query?.iCountryId
        if (query?.bCappedPlayer) query.bCappedPlayer = query?.bCappedPlayer === 'true'
        if (query?.nOrder) query.nOrder = Number(query?.nOrder)
        const { sSearch, iPrimaryTeam, iCountryId, sPlayingRole, eAuctionStatus, iTeamId, bCappedPlayer, sSortBy, nOrder } = query
        api.push(
          queryGraphql(GET_LIST_AUCTION_PLAYER, {
            input: {
              nLimit: 10,
              nSkip: 0,
              sSearch,
              iPrimaryTeam,
              eAuctionStatus,
              iCountryId,
              iTeamId,
              sSortBy,
              nOrder,
              sPlayingRole,
              bCappedPlayer,
              iSeriesId: category?.oAuctionSeries?._id
            }
          })
        )
        if (iTeamId && category?.oAuctionSeries?._id) {
          api.push(queryGraphql(IPL_AUCTION_TEAMS_BY_ID, { input: { iTeamId, iAuctionSeriesId: category?.oAuctionSeries?._id } }))
        }
        const [subPages, { value: auctionPlayerList }, teamDetail] = await Promise.allSettled(api)
        rData = {
          ...rData,
          subPages: subPages.value?.data?.getSeosBySlug || null,
          auctionPlayerList: auctionPlayerList?.data,
          teamDetail: teamDetail?.value?.data?.getAuctionTeamFront?.oData || null
        }
      } else if (tabType === 'news') {
        api.push(queryGraphql(GET_CATEGORY_NEWS_VIDEOS, { input: { ...payload(16), iCategoryId: category?._id, eType: 'n' } }))
        const [subPages, article] = await Promise.allSettled(api)
        rData = {
          ...rData,
          subPages: subPages.value?.data?.getSeosBySlug || null,
          home: {
            oArticles: article?.value?.data?.listSimpleCategoryArticlesVideosFront?.oArticles || null
          }
        }
      } else if (tabType === 'live-blog' && category?.iLiveArticleId) {
        // } else if (tabType === 'live-blog') {
        const liveArticleData = {}
        const { getLiveArticleData } = await import('@shared/libs/live-article')
        api.push(getLiveArticleData({ iEventId: category?.iLiveArticleId }))
        const [subPages, live] = await Promise.allSettled(api)
        liveArticleData.iEventId = category?.iLiveArticleId
        liveArticleData.oLiveArticleList = live?.value?.oLiveArticleList || null
        liveArticleData.oLiveArticleEvent = live?.value?.oLiveArticleEvent || null
        rData = { ...rData, liveArticleData: liveArticleData, subPages: subPages.value?.data?.getSeosBySlug || null }
      }
    } else if (category?.eType === 'fac') {
      const [article, fantasyArticle] = await Promise.allSettled([
        queryGraphql(GET_CATEGORY_NEWS_VIDEOS, { input: { ...payload(isAmp ? 32 : 16), iCategoryId: category?._id, eType: 'n' } }),
        queryGraphql(GET_FANTASY_ARTICLE_OF_CATEGORY, { input: { ...payload(16), iId: seo?.iId } })
      ])
      rData = {
        ...rData,
        home: {
          oArticles: article?.value?.data?.listSimpleCategoryArticlesVideosFront?.oArticles || null,
          fantasyArticle: fantasyArticle?.value?.data?.listFrontTagCategoryFantasyArticle || null
        }
      }
    } else {
      const api = [
        queryGraphql(GET_CATEGORY_NEWS_VIDEOS, { input: { ...payload(isAmp ? 32 : 16), iCategoryId: category?._id, eType: 'n' } }),
        queryGraphql(GET_CATEGORY_NEWS_VIDEOS, { input: { ...payload(isAmp ? 16 : 7), iCategoryId: category?._id, eType: 'v' } })
      ]
      // if (isAmp) api.push(getBannerSeriesScoreCard())
      const [article, video, promotionData] = await Promise.allSettled(api)
      rData = {
        ...rData,
        bannerSeriesScoreCard: promotionData?.value || null,
        home: {
          oArticles: article?.value?.data?.listSimpleCategoryArticlesVideosFront?.oArticles || null,
          oVideos: video?.value?.data?.listSimpleCategoryArticlesVideosFront?.oVideos || null
        }
      }
    }
  }
  return rData
}
